import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/shared/ui';
import { TOOLS, ToolCategory, type ToolConfig } from '@/shared/config/tools';

export function ToolGrid({
  category,
  tools: providedTools,
}: {
  category?: ToolCategory;
  tools?: readonly ToolConfig[];
}) {
  const tools = providedTools ?? (category ? TOOLS.filter((t) => t.category === category) : TOOLS);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {tools.map((tool) => (
        <Link
          key={tool.id}
          to={tool.path}
          className="group block rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Card className="h-full p-5 transition-all group-hover:-translate-y-0.5 group-hover:border-primary/40 group-hover:shadow-md">
            <div className="flex items-start gap-3">
              <div className="rounded-lg bg-primary/10 p-2 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <tool.icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <h3 className="mb-1 font-semibold leading-snug transition-colors group-hover:text-primary">
                  {tool.name}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{tool.description}</p>
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
}
